import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Infini Buildcomm</h3>
            <p className="text-gray-300">
              Your trusted partner for construction materials. 
              Quality products from verified vendors.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/products" className="hover:text-white">Products</a></li>
              <li><a href="/vendors" className="hover:text-white">Vendors</a></li>
              <li><a href="/about" className="hover:text-white">About Us</a></li>
              <li><a href="/contact" className="hover:text-white">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="text-gray-300 space-y-2">
              <p>Email: info@infinibuildcomm.com</p>
              <p>Phone: +1 (555) 123-4567</p>
              <p>Address: 123 Construction Ave, Build City</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p>&copy; 2025 Infini Buildcomm. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
